<template>
    <div class="container-fluid">
        <pre :class="$style.export"><code>{{ cleanedSystems }}</code></pre>
    </div>
</template>

<script>
import SystemService from '@/services/systemService';
export default {
    data () {
        return {
            systems: []
        };
    },
    computed: {
        cleanedSystems () {
            return this.systems.map(s => {
                delete s.id;
                delete s.createdAt;
                delete s.updatedAt;
                return s;
            }).reverse();
        }
    },
    methods: {
        async getSystems () {
            this.systems = (await SystemService.getSystems({ userHash: this.$ls.get('userHash') })).data.systems;
        }
    },
    async mounted () {
        this.getSystems();
    }
};
</script>

<style module>
    .export {
        background-color: white;
    }
</style>
